import dateFormat from "dateformat";
import LanguagePack from "../../../../../shared/lib/html5-software-library/src/ranj/language/LanguagePack";
import GameModel from "../model/GameModel";
import BaseEndScreenMediator from "../../../../../shared/src/ranj/equalture/view/BaseEndScreenMediator";

export default class EndScreenMediator extends BaseEndScreenMediator {

    /**
     * @param {createjs.DisplayObject} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LanguagePack} languagePack 
     * @param {GameModel} gameModel 
     */
    constructor(target, dispatcher, languagePack, layoutManager, soundManager, appModel, gameModel) {
        super(target, dispatcher, languagePack, layoutManager, soundManager, appModel);
        this._gameModel = gameModel;
    }

    initializeTexts() {
        if (this._gameModel.hasNextPuzzle() || !this._gameModel.wasLastPuzzleSuccessful()) {
            this.titleText = this.getText("end.failureTitle");
            this.bodyText = this.getText("end.failureBody");
        } else {
            this.titleText = this.getText("end.successTitle");
            this.bodyText = this.getText("end.successBody");
        }        
        this.buttonText = this.getText("end.button");
    }
};
